import { Directive, OnInit, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { startWith, filter } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { InputErrors } from './input-errors';

@UntilDestroy()
@Directive({
   selector: '[libInputErrors]',
   inputs: [ 'control', 'prefix', 'suffix' ],
})
export class InputErrorsDirective implements OnInit {
   control: FormControl;
   prefix = '';
   suffix = '';

   constructor( private el: ElementRef ) { }

   ngOnInit() {
      this.control?.valueChanges.pipe(
         startWith( true ),
         filter( _ => !!this.control?.errors ),
         untilDestroyed( this ),
      ).subscribe( _ => {
         Object.keys( this.control?.errors ).map( e => {
            const errorText = InputErrors[e]( this.control.errors[e] );
            if ( errorText ) {
               this.el.nativeElement.innerHTML = `${this.prefix}${errorText}${this.suffix}`;
            }
         });
      });
   }
}
